import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "row justify-content-center" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_4 = { class: "mb-15 mb-md-30 d-sm-flex align-items-center justify-content-between" }
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "align-items-center col-7" }
const _hoisted_7 = { class: "reviews-select rounded-1 d-flex align-items-center me-10 mt-10 mt-lg-0" }
const _hoisted_8 = ["value"]
const _hoisted_9 = { class: "form-group col-5" }
const _hoisted_10 = { class: "table-responsive" }
const _hoisted_11 = { class: "table text-nowrap align-middle mb-0" }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = {
  key: 0,
  class: "shadow-none lh-1 fw-medium text-paragraph"
}
const _hoisted_14 = ["onClick"]
const _hoisted_15 = { key: 1 }
const _hoisted_16 = { key: 0 }
const _hoisted_17 = ["onClick"]
const _hoisted_18 = {
  class: "dropdown-item d-flex align-items-center fw-bold text-primary",
  href: "javascript:void(0);"
}
const _hoisted_19 = { key: 1 }
const _hoisted_20 = ["onClick"]
const _hoisted_21 = {
  key: 2,
  class: "word-breaker"
}
const _hoisted_22 = { class: "d-md-flex mt-15 mt-md-25 mb-0 justify-content-between align-items-center" }
const _hoisted_23 = { class: "mb-0 text-paragraph" }
const _hoisted_24 = { class: "fw-bold" }
const _hoisted_25 = { class: "pagination-area d-md-flex align-items-center mt-10 mt-md-0" }
const _hoisted_26 = { class: "mb-0 text-paragraph" }
const _hoisted_27 = { class: "fw-bold" }
const _hoisted_28 = { class: "fw-bold" }
const _hoisted_29 = { class: "mt-12 mt-md-0 ms-md-20" }
const _hoisted_30 = { class: "pagination mb-0" }
const _hoisted_31 = { class: "page-item" }
const _hoisted_32 = ["onClick"]
const _hoisted_33 = { class: "page-item" }
const _hoisted_34 = {
  class: "page-link",
  "aria-label": "Next"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Filter = _resolveComponent("Filter")!
  const _component_SelectionModal = _resolveComponent("SelectionModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.tableOptions != undefined && _ctx.tableOptions.filter != undefined)
        ? (_openBlock(), _createElementBlock("span", _hoisted_2, [
            _createVNode(_component_Filter, {
              tableFilter: _ctx.tableOptions.filter,
              onTableFilterChanged: _ctx.handleTableFilterChanged,
              ref: "filterRef"
            }, null, 8, ["tableFilter", "onTableFilterChanged"])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[6] || (_cache[6] = _createElementVNode("div", {
            class: "row",
            disabled: true
          }, null, -1)),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _cache[5] || (_cache[5] = _createElementVNode("span", { class: "text-muted fs-12 position-relative fw-medium text-uppercase" }, " Zobrazit ", -1)),
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedMaxRecordsPerPage) = $event)),
                  class: "project-select form-select shadow-none fw-semibold rounded-1 mt-10 mt-sm-0 ms-sm-10"
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.availableRecordsPerPage, (option) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: option,
                      value: option.value
                    }, _toDisplayString(option.text), 9, _hoisted_8))
                  }), 128))
                ], 512), [
                  [_vModelSelect, _ctx.selectedMaxRecordsPerPage]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_9, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.tableFulltextFilter) = $event)),
                onKeyup: _cache[2] || (_cache[2] = ($event: any) => (_ctx.filterTable(_ctx.tableFulltextFilter))),
                class: "form-control shadow-none text-black rounded-0 border-0",
                placeholder: "Filtr"
              }, null, 544), [
                [_vModelText, _ctx.tableFulltextFilter]
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("table", _hoisted_11, [
            _createElementVNode("thead", null, [
              _createElementVNode("tr", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tableOptions.headers, (item, key) => {
                  return (_openBlock(), _createElementBlock("th", {
                    key: key,
                    scope: "col",
                    onClick: ($event: any) => (_ctx.sortTable(item.key)),
                    class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0"
                  }, [
                    _createElementVNode("a", null, _toDisplayString(item.text), 1),
                    _createElementVNode("i", {
                      class: _normalizeClass(["lh-1 position-relative top-1", (_ctx.sortList.get(item.key)=='ASC'?'flaticon-chevron-3':'flaticon-chevron-2')]),
                      style: _normalizeStyle({visibility: _ctx.orderVisible(item.key)})
                    }, null, 6)
                  ], 8, _hoisted_12))
                }), 128))
              ])
            ]),
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.localTableData, (value, key) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: key,
                  class: "shadow-none fw-medium text-black product-title"
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.localTableData[key], (item, innerKey) => {
                    return (_openBlock(), _createElementBlock(_Fragment, { key: innerKey }, [
                      (_ctx.tableOptions.headers.some((element) => element.key.includes(innerKey)))
                        ? (_openBlock(), _createElementBlock("td", _hoisted_13, [
                            (_ctx.tableOptions.redirects.some((element) => element.key.includes(innerKey)) && _ctx.tableOptions.headers.some((element) => element.key.includes(innerKey)))
                              ? (_openBlock(), _createElementBlock("a", {
                                  key: 0,
                                  class: "dropdown-item d-flex align-items-center fw-bold text-primary",
                                  href: "javascript:void(0);",
                                  onClick: ($event: any) => (_ctx.handleRedirect(innerKey, 
                      Array.isArray((_ctx.tableOptions.redirects.find((element) => element.key.includes(innerKey))).key)
                      ? (_ctx.tableOptions.redirects.find((element) => element.key.includes(innerKey))).key.map(selection => _ctx.localTableData[key][selection])
                      : (item.value != undefined)?item.value:item
                      ))
                                }, _toDisplayString(_ctx.capitalizeString(_ctx.tableOptions.headers.find((element) => element.key.includes(innerKey)).capitalizedString, (item.text != undefined && (item.text != null && item.text).trim().length > 0)?item.text:(typeof(item)=="object")?item.value:item)), 9, _hoisted_14))
                              : (_ctx.tableOptions.modalSelection != undefined && _ctx.tableOptions.modalSelection.some((element) => element.key == innerKey))
                                ? (_openBlock(), _createElementBlock("span", _hoisted_15, [
                                    (item.length < 4)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_16, [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item, (idList) => {
                                            return (_openBlock(), _createElementBlock("span", {
                                              key: idList,
                                              onClick: ($event: any) => (_ctx.handleRedirect((_ctx.tableOptions.modalSelection.find(element => element.key = innerKey).key), idList.value))
                                            }, [
                                              _createElementVNode("a", _hoisted_18, _toDisplayString((idList.text != undefined && (idList.text).trim().length > 0)?idList.text:(idList.text != undefined && (idList.text).trim().length==0 || idList.text == null)?idList.value:idList), 1)
                                            ], 8, _hoisted_17))
                                          }), 128))
                                        ]))
                                      : (_ctx.tableOptions.modalSelection != undefined)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_19, [
                                            _createElementVNode("button", {
                                              onClick: ($event: any) => (_ctx.triggerInstallationSelection(_ctx.tableOptions.modalSelection.find(element => element.key = innerKey), item)),
                                              class: "default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-success fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0"
                                            }, "Vybrat instalaci", 8, _hoisted_20)
                                          ]))
                                        : _createCommentVNode("", true)
                                  ]))
                                : (_openBlock(), _createElementBlock("span", _hoisted_21, _toDisplayString(_ctx.handleDateTransform(item)), 1))
                          ]))
                        : _createCommentVNode("", true)
                    ], 64))
                  }), 128))
                ]))
              }), 128))
            ])
          ]),
          _createElementVNode("div", _hoisted_22, [
            _createElementVNode("span", _hoisted_23, [
              _cache[7] || (_cache[7] = _createTextVNode(" Celkový počet záznamů: ", -1)),
              _createElementVNode("span", _hoisted_24, _toDisplayString(_ctx.tableData.totalRecords), 1)
            ]),
            _createElementVNode("div", _hoisted_25, [
              _createElementVNode("p", _hoisted_26, [
                _cache[8] || (_cache[8] = _createTextVNode(" Zobrazuji ", -1)),
                _createElementVNode("span", _hoisted_27, _toDisplayString(_ctx.paginatorCurrentPage), 1),
                _cache[9] || (_cache[9] = _createTextVNode(" ze ", -1)),
                _createElementVNode("span", _hoisted_28, _toDisplayString(_ctx.totalPaginatorTabs), 1)
              ]),
              _createElementVNode("nav", _hoisted_29, [
                _createElementVNode("ul", _hoisted_30, [
                  _createElementVNode("li", _hoisted_31, [
                    _createElementVNode("a", {
                      class: "page-link",
                      "aria-label": "Previous",
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.paginatorCurrentPage=(_ctx.paginatorCurrentPage>1)?_ctx.paginatorCurrentPage-1:_ctx.paginatorCurrentPage))
                    }, [...(_cache[10] || (_cache[10] = [
                      _createElementVNode("i", { class: "flaticon-chevron-1" }, null, -1)
                    ]))])
                  ]),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.availablePaginatorGroups, (index) => {
                    return (_openBlock(), _createElementBlock("li", {
                      key: index,
                      class: "page-item"
                    }, [
                      _createElementVNode("a", {
                        class: _normalizeClass(["page-link", (index == _ctx.paginatorCurrentPage)?'active':'']),
                        onClick: ($event: any) => (_ctx.changePaginatorPage(index))
                      }, _toDisplayString(index), 11, _hoisted_32)
                    ]))
                  }), 128)),
                  _createElementVNode("li", _hoisted_33, [
                    _createElementVNode("a", _hoisted_34, [
                      _createElementVNode("i", {
                        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.paginatorCurrentPage=(_ctx.paginatorCurrentPage<_ctx.totalPaginatorTabs)?_ctx.paginatorCurrentPage+1:_ctx.paginatorCurrentPage)),
                        class: "flaticon-chevron"
                      })
                    ])
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    _createVNode(_component_SelectionModal, { ref: "selectionRef" }, null, 512)
  ], 64))
}